import config from '../environment/config.json';

export const CONFIG = {
    REACT_APP_IA_DATA_COLLECTOR_API_BASE_URL: config.reactAppIaDataCollectorApiBaseUrl,
    REACT_APP_IA_VISUALIZATION_API_BASE_URL: config.reactAppIaVisualizationApiBaseUrl,
    REACT_APP_IA_BACKEND_API_BASE_URL: config.reactAppIaBackendApiBaseUrl,
    REACT_APP_ORG_API_BASE_URL: config.reactAppOrgApiBaseUrl,
    KEYCLOAK_URL: config.keycloakUrl,
    KEYCLOAK_REALM: config.keycloakRealm,
    KEYCLOAK_CLIENT_ID: config.keycloakClientId
}